import { Card, Avatar, Button, message } from 'antd';
import { UserOutlined, LikeOutlined, CommentOutlined, MessageOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { expertLike, expertUnLike } from '../../server/api';
import s from './index.module.css';
import defaultAvatar from '../../asset/avatar.png';

const ExpertCard = ({ expert = {}, onClick }) => {
  const { expert: expertInfo = {}, likeCount } = expert;
  const { id, expertName, expertise, avatarUrl, description, goodRate, consultationCount } = expertInfo;
  const history = useHistory();

  const handleConsultation = (e) => {
    e.stopPropagation();

    // 检查用户登录状态
    const savedUserInfo = sessionStorage.getItem('userInfo');
    if (!savedUserInfo) {
      message.error('请先登录后再进行咨询');
      return;
    }

    history.push(`/consultation/create/${id}`);
  };

  return (
    <Card
      className={s.expertCard}
      hoverable
      bodyStyle={{ padding: '24px 20px' }}
    >
      <div className={s.expertCardContent}>
        {/* 头像 */}
        <div className={s.expertAvatarSection}>
          <Avatar
            size={80}
            src={avatarUrl || defaultAvatar}
            icon={<UserOutlined />}
            className={s.expertAvatar}
          />
        </div>

        {/* 用户名和ID */}
        <div className={s.expertInfo}>
          <h4 className={s.expertName}>{expertName}</h4>
          <p className={s.expertId}>擅长领域: {expertise}</p>
        </div>

        {/* 统计数据 */}
        <div className={s.expertStats}>
          <div className={s.statItem}>
            <CommentOutlined className={s.statIcon} />
            <span className={s.statNumber}>{consultationCount || 0}</span>
          </div>
          <div className={s.statItem}>
            <LikeOutlined className={s.statIcon} />
            <span className={s.statNumber}>{`${likeCount}`}</span>
          </div>
        </div>

        {/* 底部操作区 */}
        <div className={s.expertActions}>
          <Button
            type="link"
            className={s.detailLink}
            onClick={(e) => {
              e.stopPropagation();
              onClick && onClick(expertInfo);
              history.push(`/experts/${expertInfo.id}`);
            }}
          >
            查看详情
          </Button>
          <Button
            type="primary"
            icon={<MessageOutlined />}
            className={s.consultationBtn}
            onClick={handleConsultation}
          >
            去咨询
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default ExpertCard;
